import { loadData } from '@/data/api';
import type { Garage, GarageLiveStatusResponse } from '@/types';
import { defineStore } from 'pinia'


const liveDataCache: {[garageId: number]: GarageLiveStatusResponse} = {};
export const useGarageStore = defineStore('garage' ,{
	state: () => ({
		garages: [] as Readonly<Garage>[],
		}),
	getters: {
		
	},
	actions: {
		setGarages(garages: Garage[]): void {
			this.garages  = garages
		},
		async liveStatus(path: string, garage: Garage): Promise<GarageLiveStatusResponse> {
			if( liveDataCache[garage.id] ) {
				return liveDataCache[garage.id];
			}
			const data = await loadData(path, {});
			liveDataCache[garage.id] = data;
			return data;
		}
	}
})
